/**
 * Created by Pali on 07/05/20.
 */

angular.module("screensApp")

  .controller("StreamController", function ($scope, $rootScope) {
    // Zobrazenie streamov, od providera MTX
    $rootScope.showStreamMTX = function (data) {
      $rootScope.hideStream(true);
      $rootScope.settings.stream.show = true;
      $rootScope.settings.stream.active = true;
      $("#streamLoading").hide();
      // Twitch nefunguje - koli portu screens app :8404
      if (data.eStreamID.includes("twitch")) {
        // spravna url: src="https://player.twitch.tv/?channel=hitmediaru5&parent=screens-svk.doxxbet.sk"
        data.eStreamID = data.eStreamID.replace("www.doxxbet.sk", window.location.hostname);
      } else if (data.eStreamID.includes("youtube")) {
        data.eStreamID = data.eStreamID.replace("www.youtube.com/watch?v=", "www.youtube.com/embed/");
      }

      var iframe = '<iframe scrolling="no" frameborder="0" style="width:100%; height:100%" src=' + data.eStreamID + "></iframe>";
      angular.element("#streamContainer.video-container").append(iframe);
    };

    // Zobrazenie streamov, ine nez od providera MTX
    $rootScope.showStream = function (data) {
      if (data.eStreamID && data.eStreamID !== $rootScope.settings.stream.fixtureID) {
        $rootScope.hideStream(true);

        $rootScope.settings.stream.show = true;
        $("#streamLoading").show();

        var sourceID = 7772; //customer ID - constant
        $rootScope.settings.stream.fixtureID = data.eStreamID; // streamID

        // Show video directly in custom div
        angular.element("#streamContainer.video-container").append('<div id="videoStream" style="width:100%; height:100%;"></div>');

        $rootScope.settings.stream.active = true;
        url = "https://drop-and-play.betstream.betgenius.com/widgetLoader?containerId=videoStream&source=" + sourceID + "&fixtureId=" + $rootScope.settings.stream.fixtureID + "&fullscreen=fullscreen";

        var script = document.createElement("script");
        script.setAttribute("src", url);
        script.setAttribute("type", "text/javascript");
        document.head.appendChild(script);

        // Check periodically
        $scope.checkvideoPlayInterval = setInterval(function () {
          if ($("#vjs_video_1").hasClass("vjs-playing") && !$("#vjs_video_1").hasClass("vjs-waiting")) {
            // video stream started playing and video is not in waiting state
            clearInterval($scope.checkvideoPlayInterval);

            $rootScope.settings.stream.active = true;
            $("#streamLoading").hide();
          } else if ($("#videoStream .emptymessage").text()) {
            // .emptymessage contains Original message: Currently, there's no stream available for this fixture
            $rootScope.settings.stream.active = false;
            $rootScope.hideStream();
          }
        }, 1000);
      }
    };

    // Hide StreamController
    $rootScope.hideStream = function (noScriptDelete) {
      clearInterval($scope.checkvideoPlayInterval);

      $rootScope.settings.stream.show = false;
      $rootScope.settings.stream.fixtureID = false;
      angular.element("#streamContainer #videoStream").remove();

      // Fix v pripade drop-and-play 'url' bez '&controls=controls&fullscreen=fullscreen'
      // if (!noScriptDelete) {
      //     $timeout(function(){
      //         var headerScripts = $('script');
      //         headerScripts.each(function(hs, headerScript) {
      //             if (headerScript && (headerScriptSrc = $(headerScript).attr('src')));
      //             // Delete head script element
      //             if (headerScriptSrc && (headerScriptSrc.includes('drop-and-play'))) {
      //                 headerScript.remove();
      //             }
      //         });
      //     }, 0);
      // }

      $rootScope.settings.stream.active = false;
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideStream()');

      // delete IFRAME video stream
      angular.element("#streamContainer iframe").remove();
    };
  });
